import { sqliteTable, text, index } from "drizzle-orm/sqlite-core";
import { conversations } from "./conversations";

// ============================================================================
// messages — ข้อความในการสนทนา
// ============================================================================
export const messages = sqliteTable(
  "chat_messages",
  {
    id: text("id").primaryKey(), // ULID
    conversationId: text("conversation_id")
      .notNull()
      .references(() => conversations.id),
    direction: text("direction").notNull(), // 'inbound' | 'outbound'
    senderType: text("sender_type").notNull(), // 'customer' | 'bot' | 'human' | 'page'
    content: text("content").notNull(),
    messageType: text("message_type").notNull().default("text"),
    /**
     * Provider-assigned message id (capability-neutral).
     * - Facebook Messenger: Messenger message id
     * - Line OA: message id from webhook
     * - Instagram DM: IG message id
     */
    providerMessageId: text("provider_message_id"),
    metadata: text("metadata"), // JSON
    // Timestamps (immutable — messages are never updated)
    createdAt: text("created_at").notNull(),
    createdBy: text("created_by"),
    deletedAt: text("deleted_at"),
    deletedBy: text("deleted_by"),
  },
  (table) => ({
    /** Hot path — every conversation-detail view hits this. */
    conversationIdIdx: index("chat_messages_conversation_id_idx").on(table.conversationId),
  })
);

export type Message = typeof messages.$inferSelect;
export type NewMessage = typeof messages.$inferInsert;
